import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

const BaseTooltip = ({
  content,
  children,
  placement = "top",
  interactive = false,
  delay = [0, 0],
  theme = "default",
  disabled = false,
}) => {
  return (
    <Tippy
      className="bg-neutral-900/75"
      content={content}
      placement={placement}
      interactive={interactive}
      delay={delay}
      theme={theme}
      disabled={disabled}
      appendTo={document.body}
    >
      {children}
    </Tippy>
  );
};

export default BaseTooltip;
